import React, { useState, useEffect } from "react";
import {
  Form,
  Col,
  Row,
  Button,
  Select,
  Collapse,
  DatePicker,
  Input,
  InputNumber,
} from "antd";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import { odata } from "./Helper";
import { getPaymentChannelConditions } from "./GetPaymentChannelConditions";

const PosCollectionTransactionTableFilter = (props) => {
  const [form] = Form.useForm();

  const [bankSelect, setBankSelect] = useState({
    data: [],
    loading: false,
  });
  const [firmSelect, setFirmSelect] = useState({
    data: [],
    loading: false,
  });

  const { Option } = Select;
  const validInstallments = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  const [subFirmSelect, setSubFirmSelect] = useState({
    data: [],
    loading: false,
  });

  const [paymentSetSelect, setPaymentSetSelect] = useState({
    data: [],
    loading: false,
  });

  const [paymentChannelSelect, setPaymentChannelSelect] = useState({
    data: [],
    loading: false,
  });

  useEffect(() => {
    getBanks();
    getPaymentChannels();
  }, []);

  useEffect(() => {
    if (props.data) {
      form.setFieldsValue(props.data);
    }
  }, [props.data]);

  const getBanks = () => {
    setBankSelect({
      ...bankSelect,
      loading: true,
    });
    RequestHandler.get(
      `/PosCollectionBankInfo/AddedBanks?$select=id,name`
    ).then((response) => {
      setBankSelect({
        data: response,
        loading: false,
      });
    });
  };

  const getPaymentChannels = () => {
    setPaymentChannelSelect({ data: [], loading: true });

    RequestHandler.get(`/PosCollectionTransaction/GetPaymentChannels`).then(
      (res) => {
        setPaymentChannelSelect({ data: res, loading: false });
      }
    );
  };

  const onFirmSeach = (value) => {
    if (value.length >= 2) {
      setFirmSelect({ ...firmSelect, loading: true });

      RequestHandler.get(
        `/Firm?$select=id,firmBranchNumber,name&$filter=${odata.contains(
          "name",
          value
        )} or ${odata.contains("firmBranchNumber", value)}`
      ).then((res) => {
        setFirmSelect({ data: res.value, loading: false });
      });
    } else {
      setFirmSelect({ data: [], loading: false });
    }
  };

  const onSubFirmSeach = (value) => {
    if (value.length >= 2) {
      setSubFirmSelect({ ...firmSelect, loading: true });

      RequestHandler.get(
        `/SubFirm?&$filter=${odata.contains("name", value)} or ${odata.contains(
          "subFirmBranchNumber",
          value
        )}`
      ).then((res) => {
        setSubFirmSelect({ data: res.value, loading: false });
      });
    } else {
      setSubFirmSelect({ data: [], loading: false });
    }
  };

  const onPaymentSetSeach = (value) => {
    if (value.length >= 2) {
      setPaymentSetSelect({ ...firmSelect, loading: true });

      RequestHandler.get(
        `/PaymentSet?&$filter=${odata.contains("name", value)}`
      ).then((res) => {
        setPaymentSetSelect({ data: res.value, loading: false });
      });
    } else {
      setPaymentSetSelect({ data: [], loading: false });
    }
  };

  const onFinish = (values) => {
    {
      let query = "";
      const conditions = [];
      if (values.bankId) {
        conditions.push(`bankId eq ${values.bankId}`);
      }

      if (values.firmId) {
        conditions.push(`firmId eq ${values.firmId}`);
      }

      if (values.success === 0) {
        conditions.push(`success eq false`);
      }

      if (values.success === 1) {
        conditions.push(`success eq true`);
      }

      if (values.success === 2) {
        conditions.push(`success eq null`);
      }
      if (values.success === 3) {
        conditions.push(`isCancel eq true`);
      }
      if (values.success === 4) {
        conditions.push(`isRefund eq true`);
      }
      if (values.success === 5) {
        conditions.push(`isPartialRefund eq true`);
      }
      if (values.authCode) {
        conditions.push(odata.contains("authCode", values.authCode));
      }

      if (values.cancelRefundRequest == 1) {
        conditions.push(`cancelRefundRequest eq 0 or cancelRefundRequest eq 1`);
      }

      if (values.cancelRefundRequest == 0) {
        conditions.push(`cancelRefundRequest eq null`);
      }

      if (values.addDateRange) {
        const [startDate, endDate] = values.addDateRange;

        conditions.push(odata.dateRange("addDate", startDate, endDate));
      }

      if (values.amountMin) {
        conditions.push(`amount Ge ${values.amountMin}`);
      }

      if (values.amountMax) {
        conditions.push(`amount Le ${values.amountMax}`);
      }

      if (values.holderName) {
        conditions.push(odata.contains("holderName", values.holderName));
      }
      if (values.cardNumber) {
        conditions.push(odata.contains("cardNumber", values.cardNumber));
      }

      if (values.installmentCount) {
        conditions.push(`installmentCount eq ${values.installmentCount}`);
      }

      if (values.subFirmId) {
        conditions.push(`subFirmId eq ${values.subFirmId}`);
      }

      if (values.paymentSetId) {
        conditions.push(`paymentSetId eq ${values.paymentSetId}`);
      }

      //~ preAuth
      if (values.preAuth === 0) {
        conditions.push(`isPreAuth eq true`);
      }

      if (values.preAuth === 1) {
        conditions.push(`isPreAuth eq true and isPreAuthSuccess eq true`);
      }

      if (values.preAuth === 2) {
        conditions.push(`isPreAuth eq true and isPreAuthSuccess ne true`);
      }
      if (values.preAuth === 3) {
        conditions.push(`isPreAuth eq true and success eq true`);
      }
      //~ preAuth

      if (values.description) {
        conditions.push(odata.contains("description", values.description));
      }
      if (values.orderId) {
        conditions.push(odata.contains("orderId", values.orderId));
      }

      if (values.isCommissionIncluded === 0) {
        conditions.push(`isCommissionIncluded eq true`);
      }
      if (values.isCommissionIncluded === 1) {
        conditions.push(`isCommissionIncluded ne true`);
      }
      if (values.serialCode) {
        conditions.push(`serialCode eq ${values.serialCode}`);
      }
      if (values.paymentChannelType !== undefined) {
        conditions.push(
          ...getPaymentChannelConditions(values.paymentChannelType)
        );
      }

      if (values.paymentMethodName) {
        conditions.push(
          odata.contains("paymentMethod", values.paymentMethodName)
        );
      }

      if (values.contractNumber) {
        conditions.push(
          odata.contains("contractNumber", values.contractNumber)
        );
      }

      if (values.paymentMethod) {
        conditions.push(odata.contains("paymentMethod", values.paymentMethod));
      }

      if (conditions.length !== 0) {
        query = conditions.join(" and ");
      }

      if (props.onFinishFilter) props.onFinishFilter(query);
    }
  };

  const clearFilter = () => {
    form.resetFields();

    if (props.onClearFilter) {
      props.onClearFilter();
    }
  };

  return (
    <Row id="filterArea" style={{ ...props.style }}>
      <Col span={24}>
        <Collapse>
          <Collapse.Panel header="Filtreleme için tıklayınız.">
            <Form
              name="filter"
              form={form}
              initialValues={{
                remember: true,
              }}
              layout="vertical"
              onFinish={onFinish}
            >
              <Row style={{ flexDirection: "row" }}>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="bankId" label="Banka :">
                    <Select
                      allowClear
                      showSearch
                      placeholder="Tümü"
                      loading={bankSelect.loading}
                      filterOption={(input, option) =>
                        option.props.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                    >
                      {bankSelect.data.map((item) => (
                        <Select.Option key={item.id} value={item.id}>
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item label="Cari" name="firmId">
                    <Select
                      allowClear
                      showSearch
                      style={{ width: "100%" }}
                      dropdownStyle={{ minWidth: "50%" }}
                      placeholder="En az 2 harf giriniz.."
                      onSearch={onFirmSeach}
                      filterOption={(input, option) =>
                        option.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
                        option.code
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={firmSelect.loading}
                    >
                      {firmSelect.data.map((item) => (
                        <Select.Option
                          key={item.id}
                          value={item.id}
                          code={item.firmBranchNumber}
                        >
                          {item.name + " ( " + item.firmBranchNumber + " ) "}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="success" label="İşlem Sonucu :">
                    <Select allowClear placeholder="Tümü">
                      {[
                        { id: 0, name: "Başarısız" },
                        { id: 1, name: "Başarılı" },
                        { id: 2, name: "Kontrol Edilecek" },
                        { id: 3, name: "İptal" },
                        { id: 4, name: "İade" },
                        { id: 5, name: "Kısmi İade" },
                      ].map((item) => (
                        <Select.Option key={item.id} value={item.id}>
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="addDateRange" label="İşlem Tarihi :">
                    <DatePicker.RangePicker
                      format="DD.MM.YYYY"
                      style={{ width: "100%" }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="authCode" label="Onay Kodu :">
                    <Input allowClear />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item
                    name="cancelRefundRequest"
                    label="İptal/İade Talebi :"
                  >
                    <Select allowClear placeholder="Tümü">
                      {[
                        { id: 1, name: "Var" },
                        { id: 0, name: "Yok" },
                      ].map((item) => (
                        <Select.Option key={item.id} value={item.id}>
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item label="Toplam Tutar :" style={{ marginBottom: 0 }}>
                    <Input.Group>
                      <Row gutter={1} style={{ flexDirection: "row" }}>
                        <Col span={12}>
                          <Form.Item name="amountMin">
                            <InputNumber min={0} style={{ width: "100%" }} />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item name="amountMax">
                            <InputNumber min={0} style={{ width: "100%" }} />
                          </Form.Item>
                        </Col>
                      </Row>
                    </Input.Group>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="holderName" label="Kart Sahibi Adı :">
                    <Input allowClear />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="installmentCount" label="Taksit Sayısı :">
                    <Select allowClear>
                      {validInstallments.map((value) => (
                        <Option key={value} value={value}>
                          {value}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="cardNumber" label="Kart Numarası :">
                    <Input allowClear />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item label="Alt Bayi" name="subFirmId">
                    <Select
                      allowClear
                      showSearch
                      placeholder="En az 2 harf giriniz.."
                      style={{ width: "100%" }}
                      dropdownStyle={{ minWidth: "30%" }}
                      filterOption={(input, option) =>
                        option.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
                        option.code
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={subFirmSelect.loading}
                      onSearch={onSubFirmSeach}
                    >
                      {subFirmSelect.data.map((item) => (
                        <Select.Option
                          key={item.id}
                          value={item.id}
                          code={item.subFirmBranchNumber}
                        >
                          {`${item.name} (${item.subFirmBranchNumber})`}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="preAuth" label="Provizyon İşlem:">
                    <Select allowClear placeholder="Tümü">
                      {[
                        { id: 0, name: "Provizyon İşlemi" },
                        { id: 1, name: "Başarılı Provizyon İşlemi" },
                        { id: 2, name: "Başarısız Provizyon İşlemi" },
                        {
                          id: 3,
                          name: "Başarılı Kapama Yapılmış Provizyon İşlemi",
                        },
                      ].map((item) => (
                        <Select.Option key={item.id} value={item.id}>
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item label="Ödeme Şekli :" name="paymentSetId">
                    <Select
                      allowClear
                      showSearch
                      placeholder="En az 2 harf giriniz.."
                      style={{ width: "100%" }}
                      dropdownStyle={{ minWidth: "30%" }}
                      filterOption={(input, option) =>
                        option.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0 ||
                        option.code
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={paymentSetSelect.loading}
                      onSearch={onPaymentSetSeach}
                    >
                      {paymentSetSelect.data.map((item) => (
                        <Select.Option
                          key={item.id}
                          value={item.id}
                          code={item.name}
                        >
                          {`${item.name}`}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="description" label="Açıklama :">
                    <Input allowClear />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="orderId" label="İşlem Numarası :">
                    <Input allowClear />
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item name="isCommissionIncluded" label="KTD İşlemi:">
                    <Select allowClear placeholder="Tümü">
                      {[
                        { id: 0, name: "Evet" },
                        { id: 1, name: "Hayır" },
                      ].map((item) => (
                        <Select.Option key={item.id} value={item.id}>
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} md={12} lg={6}>
                  <Form.Item
                    name="serialCode"
                    label="Seri No :"
                    rules={[
                      {
                        type: "number",
                        message: "Lütfen geçerli bir sayı giriniz.",
                      },
                    ]}
                  >
                    <InputNumber allowClear style={{ width: "100%" }} />
                  </Form.Item>
                </Col>

                <Col xs={24} md={12} lg={6}>
                  <Form.Item label="Ödeme Kanalı" name="paymentChannelType">
                    <Select
                      allowClear
                      showSearch
                      filterOption={(input, option) =>
                        option.children
                          .toLocaleLowerCase("tr-TR")
                          .indexOf(input.toLocaleLowerCase("tr-TR")) >= 0
                      }
                      loading={paymentChannelSelect.loading}
                    >
                      {paymentChannelSelect.data.map((item) => (
                        <Select.Option key={item.id} value={item.id}>
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                {props?.b2BIsUseAdditionalFieldForPolicy && (
                  <Col xs={24} md={12} lg={6}>
                    <Form.Item
                      label="Sigorta Şirketi Adı :"
                      name="paymentMethodName"
                    >
                      <Input></Input>
                    </Form.Item>
                  </Col>
                )}
                {props?.showCustomFields && (
                  <Col xs={24} md={12} lg={6}>
                    <Form.Item
                      label="Sözleşme Numarası :"
                      name="contractNumber"
                      rules={[{ max: 50 }]}
                    >
                      <Input type="number" maxLength="50" />
                    </Form.Item>
                  </Col>
                )}
                {props?.showCustomFields && (
                  <Col xs={24} md={12} lg={6}>
                    <Form.Item
                      label="Ödeme Tipi :"
                      name="paymentMethod"
                      rules={[{ max: 50 }]}
                    >
                      <Input maxLength={200} />
                    </Form.Item>
                  </Col>
                )}
                {props?.useCarRentalFields && (
                  <Col xs={24} md={12} lg={6}>
                    <Form.Item label="Ödeme Kodu :" name="paymentMethod">
                      <Input></Input>
                    </Form.Item>
                  </Col>
                )}
              </Row>

              <Row style={{ flexDirection: "row" }}>
                <Col span={24} style={{ textAlign: "right" }}>
                  <Button
                    danger
                    size="small"
                    icon={<CloseOutlined />}
                    onClick={() => clearFilter()}
                  >
                    Sıfırla
                  </Button>
                  <Button
                    type="primary"
                    size="small"
                    icon={<SearchOutlined />}
                    style={{ color: "#40a9ff", borderColor: "#40a9ff" }}
                    htmlType="submit"
                  >
                    Filtrele
                  </Button>
                </Col>
              </Row>
            </Form>
          </Collapse.Panel>
        </Collapse>
      </Col>
    </Row>
  );
};
export default PosCollectionTransactionTableFilter;
